import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { armazenamento } from './armazenamento.ts';

/**
 * ADR 0027 — o curso em que o estudante estava, para o «Aprender» da barra
 * de topo o levar direito à página desse curso, como na referência: quem
 * abre a aplicação quer voltar a onde ia, não escolher o curso outra vez.
 *
 * Guarda-se o identificador da trilha e nada mais — o progresso vive na
 * lição. Sem curso guardado, «Aprender» leva ao catálogo, que é onde se
 * escolhe.
 */
interface Estado {
  trilha: string | null;
  definir(trilha: string): void;
  /** O curso guardado deixou de existir: «Aprender» volta a levar ao catálogo. */
  limpar(): void;
}

export const useCursoActual = create<Estado>()(
  persist(
    (set) => ({
      trilha: null,
      definir: (trilha) => set({ trilha }),
      limpar: () => set({ trilha: null }),
    }),
    { name: 'curso-actual', storage: armazenamento() },
  ),
);
